import { useState } from "react";
import { useTranslation } from "react-i18next";

const FILTERS = ["all", "very_disappointed", "somewhat_disappointed", "not_disappointed"];

export default function PmfTextResponses({ responses }) {
    const { t } = useTranslation();
    const [filter, setFilter] = useState("all");

    const filtered = filter === "all"
        ? responses
        : responses.filter((r) => r.disappointment === filter);

    return (
        <div>
            <div className="flex gap-2 mb-4 flex-wrap">
                {FILTERS.map((f) => (
                    <button
                        key={f}
                        onClick={() => setFilter(f)}
                        className={`px-3 py-1.5 text-xs font-medium rounded-full transition-colors ${
                            filter === f
                                ? "bg-blue-100 text-blue-700"
                                : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                        }`}
                    >
                        {f === "all" ? t("survey.admin.all") : t(`survey.${f}`)}
                    </button>
                ))}
            </div>
            <div className="space-y-3">
                {filtered.map((r) => (
                    <div key={r.id} className="bg-white border border-slate-200 rounded-lg p-4">
                        <div className="flex items-center justify-between mb-2">
                            <span className="text-sm font-medium text-slate-900">
                                {r.user?.firstName} {r.user?.lastName}
                            </span>
                            <span className="text-xs text-slate-400">
                                {new Date(r.createdAt).toLocaleDateString()}
                            </span>
                        </div>
                        <span className="inline-block text-xs px-2 py-0.5 rounded-full mb-3 bg-slate-100 text-slate-600">
                            {t(`survey.${r.disappointment}`)}
                        </span>
                        <div className="space-y-2 text-sm text-slate-700">
                            <div>
                                <p className="text-xs text-slate-400">{t("survey.q2Short")}</p>
                                <p>{r.benefitPersona}</p>
                            </div>
                            <div>
                                <p className="text-xs text-slate-400">{t("survey.q3Short")}</p>
                                <p>{r.mainBenefit}</p>
                            </div>
                            <div>
                                <p className="text-xs text-slate-400">{t("survey.q4Short")}</p>
                                <p>{r.improvement}</p>
                            </div>
                        </div>
                    </div>
                ))}
                {filtered.length === 0 && (
                    <p className="text-center text-slate-400 py-8">
                        {t("survey.admin.noResponses")}
                    </p>
                )}
            </div>
        </div>
    );
}
